import { render, staticRenderFns } from "./CommentsMenu.vue?vue&type=template&id=01f337b0&"
import script from "./CommentsMenu.vue?vue&type=script&lang=js&"
export * from "./CommentsMenu.vue?vue&type=script&lang=js&"
import style0 from "./CommentsMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VChip,VIcon,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01f337b0')) {
      api.createRecord('01f337b0', component.options)
    } else {
      api.reload('01f337b0', component.options)
    }
    module.hot.accept("./CommentsMenu.vue?vue&type=template&id=01f337b0&", function () {
      api.rerender('01f337b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/proposal/proposal-renderer/CommentsMenu.vue"
export default component.exports